function pick(value, allowed, fallback) {
    return value != null && allowed.includes(value) ? value : fallback;
}
/** Resolve theme + layout with URL → env → default precedence. */
function themeFromQuery(params, keys) {
    for (const key of keys) {
        const value = params.get(key);
        if (value != null)
            return value;
    }
    return null;
}
export function resolveThemeLayout(src, opts) {
    const params = new URLSearchParams(src.search ?? "");
    const themeKeys = opts.themeQueryKeys ?? ["theme"];
    return {
        theme: pick(themeFromQuery(params, themeKeys) ?? src.envTheme, opts.themes, opts.defaultTheme),
        layout: pick(params.get("layout") ?? src.envLayout, opts.layouts, opts.defaultLayout),
    };
}
//# sourceMappingURL=siteVariant.js.map